<template>
  <div class="page-header">
    <div class="container">
      <div class="text-right">
        <contact-us />
      </div>

      <div class="row content">
        <div class="col-xs-12">
          <h1>
            Compare and switch in just four simple steps
          </h1>
          <p>
            Explore the market to find a cheaper, greener energy deal for you and your home
          </p>
          <slot></slot>
        </div>

        <div class="logo"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUs from '../contact-us/ContactUs';
export default {
  name: 'PageHeader',
  components: { ContactUs }
};
</script>

<style lang="scss">
.page-header {
  background: rgb(255, 64, 187);
  background: linear-gradient(-45deg, $brand-colour-secondary 0%, $brand-colour-primary 100%);
  padding: 40px 0 30px 0;
  margin: 0;
  border: none;

  h1 {
    font-size: 40px;
    margin: 0;
    line-height: 1.2;
    color: #fff;
    -webkit-text-fill-color: white;
    /* Will override color (regardless of order) */
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
    letter-spacing: 0.5px;
  }

  p {
    font-size: 20px;
  }

  .content {
    position: relative;
    padding-right: 270px;

    .logo {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0, -50%);
      height: 200px;
      width: 200px;
      background: url('../../../assets/logo-lg.png') no-repeat;
      background-size: contain;
      display: inline-block;
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
    }

    p {
      font-size: 15px;
    }

    .content {
      padding-right: 0;
      padding-top: 100px;

      .logo {
        position: absolute;
        right: auto;
        left: 15px;
        top: 20px;
        transform: translate(0, 0);
        height: 80px;
        width: 170px;
      }
    }
  }
}
</style>
